export default __webpack_public_path__ + "static/stream-69e8dd19b346362271ec0ce486b2f5b7.png";